import type { PatientProfile } from "@/core/types";

export const shouldUpdateInsurance = (profile: PatientProfile): boolean => {
  const insurance_status = profile?.chc_info?.status;
  const show_insurance_task = ["declined", "no_match"];

  return show_insurance_task.includes(insurance_status);
};
